import { useEffect, useRef, useState } from "react";
import { Plane, MapPin } from "lucide-react";

// Signature interaction: a small airplane travels a vertical rail as the user
// scrolls their journey, reaching Portugal (pin) at the very end.
export function AirplaneProgress({ milestones = 10 }) {
  const [progress, setProgress] = useState(0);
  const raf = useRef(0);

  useEffect(() => {
    const update = () => {
      const h = document.documentElement.scrollHeight - window.innerHeight;
      const p = h > 0 ? Math.min(1, Math.max(0, window.scrollY / h)) : 0;
      setProgress(p);
    };
    const onScroll = () => {
      cancelAnimationFrame(raf.current);
      raf.current = requestAnimationFrame(update);
    };
    update();
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);
    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onScroll);
      cancelAnimationFrame(raf.current);
    };
  }, []);

  const arrived = progress > 0.985;

  return (
    <>
      {/* Desktop vertical rail */}
      <div data-testid="airplane-progress" className="hidden xl:flex fixed right-8 top-1/2 -translate-y-1/2 z-40 flex-col items-center h-[52vh] pointer-events-none">
        <div className="relative w-px flex-1 bg-warm/15">
          <div className="absolute top-0 left-0 w-px bg-gold" style={{ height: `${progress * 100}%` }} />
          {Array.from({ length: milestones }).map((_, i) => {
            const top = (i / (milestones - 1)) * 100;
            const passed = progress * 100 >= top - 1;
            return (
              <span
                key={i}
                className={`absolute -left-[3px] h-1.5 w-1.5 rounded-full transition-colors duration-300 ${passed ? "bg-gold" : "bg-warm/25"}`}
                style={{ top: `${top}%` }}
              />
            );
          })}
          {/* airplane */}
          <div className="absolute -left-[10px] transition-[top] duration-150 ease-out" style={{ top: `${progress * 100}%` }}>
            <div className="-translate-y-1/2">
              <Plane className={`h-5 w-5 ${arrived ? "text-terracotta" : "text-gold"} drop-shadow`} style={{ transform: "rotate(135deg)" }} strokeWidth={1.75} />
            </div>
          </div>
        </div>
        <MapPin className={`mt-3 h-5 w-5 transition-colors ${arrived ? "text-terracotta" : "text-warm/30"}`} strokeWidth={1.75} />
        <span className={`mt-1 text-[10px] tracking-widest transition-colors ${arrived ? "text-terracotta" : "text-warm/30"}`}>PT</span>
      </div>

      {/* Mobile / tablet top bar */}
      <div className="xl:hidden fixed top-0 inset-x-0 z-[60] h-0.5 bg-transparent pointer-events-none">
        <div className="h-full bg-gold transition-[width] duration-150" style={{ width: `${progress * 100}%` }} />
      </div>
    </>
  );
}
